module.exports = __webpack_public_path__ + "static/media/subICloud2.2614b8e6.png";